<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="x-button" @click="$emit('close')">&times;</div>

          <div class="modal-body" style="min-height: calc(95vh - 141px);">
            <slot name="body">
              <div>
                <md-table>
                    <md-table-row>
                      <md-table-head>EDITED BY</md-table-head>
                      <md-table-head>DATE</md-table-head>
                    </md-table-row>
                    <template v-if="articleHistory.length > 0">
                        <md-table-row v-for="(item, key) in articleHistory" :key="key">
                            <md-table-cell>{{ item.editedBy.user }}</md-table-cell>
                            <md-table-cell>{{ $moment(item.editedBy.timestamp * 1000) | moment("hh:mm DD/MM/YYYY") }}</md-table-cell>
                            <md-table-cell><button @click="restore(item)">RESTORE</button></md-table-cell>
                        </md-table-row>
                    </template>
                </md-table>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('close')">Done</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import ModalButton from "../ModalButton.vue";
require("firebase/firestore");

export default {
  name: "modal",
  props: ["id"],
  components: {
      ModalButton
  },
  data: function() {
    return {
      articleHistory: []
    };
  },
  mounted: function() {
    firebase.firestore().collection("postContent")
        .doc(this.id)
        .collection("history")
        .orderBy("editedBy.timestamp", "desc")
        .get()
        .then(snap => {
          this.articleHistory = snap.docs.map((documentSnapshot) => {
            return documentSnapshot.data();
          });
          console.log(this.articleHistory);
        });
  },
  methods: {
    restore(article) {
      this.$emit("restore",article);
      this.$emit("close");
    }
  }
};
</script>



<style scoped>
.md-content.md-table.md-theme-default {
  max-height: calc(95vh - 141px);
}
.x-button {
  margin-left: auto;
  cursor: pointer;
  font-size: 30px;
}
.modal-mask {
  overflow-y: scroll;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
img {
  max-width: 300px;
}
.flex1 {
  margin-left: 5px;
}
.flex1 h2 {
  margin: 0;
  border: none;
}
.flex1 p {
  margin: 3px 0 3px 0;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 95vh;
  color: black;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #5f5f5f;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
  .md-content {
    max-width: 100%;
        padding: 10px;
    overflow: auto;
  }

/* .modal-default-button {

} */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding: 5px;
}
.modal-footer button {
  margin: 0 5px;
  height: 30px;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (min-width: $responsive_breakpoint_min) {
  .scrolling-wrapper-flexbox {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
}
@media screen and (max-width: $responsive_breakpoint_max) {
  .scrolling-wrapper-flexbox {
    overflow-x: scroll;
  }
  .video-scroll-button {
    display: none !important;
  }
}
.scrolling-wrapper-flexbox {
  display: flex;
  flex-wrap: nowrap;

  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.card {
  border: 1px solid white;
  width: 150px;
  flex: 0 0 auto;
  margin-right: 3px;
}
.card img {
  width: 150px;
}

.video-block {
  position: relative;
  margin-left: 20px;
  max-width: 300px;
}

input {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// history.vue?633144ac